// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__LFDy-","rootSuccess":"CompleteLink_rootSuccess__1RwH2","rootFailure":"CompleteLink_rootFailure__Kf_s7","isDisabled":"CompleteLink_isDisabled__eT1rM"};